import React from 'react'
import BackBtn from '../assets/images/backBtn.png'
export default function SideBarBack ({ handleCloseDrawer, className=null }) {
  return (
    <img
      loading='lazy'
      src={BackBtn}
      className={`backdes m-0 cursor-pointer ${className}`}
      alt='back'
      onClick={handleCloseDrawer}
    />
  )
}
